<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" @click="$emit('close')" icon>
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูลสินค้า
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('ชื่อจริง') }"
          >
            <label>{{ $t('ชื่อจริง') }}</label>
            <input
              :data-vv-as="$t('ชื่อจริง')"
              v-validate="'required'"
              v-model="input.firstName"
              class="form-control"
              type="text"
              name="ชื่อจริง"
            />
            <span class="text-error" v-if="errors.has('ชื่อจริง')">{{
              errors.first('ชื่อจริง')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('นามสกุล') }"
          >
            <label>{{ $t('นามสกุล') }}</label>
            <input
              :data-vv-as="$t('นามสกุล')"
              v-validate="'required'"
              v-model="input.lastName"
              class="form-control"
              type="text"
              name="นามสกุล"
            />
            <span class="text-error" v-if="errors.has('นามสกุล')">{{
              errors.first('นามสกุล')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('เบอร์โทรศัพท์') }"
          >
            <label>{{ $t('เบอร์โทรศัพท์') }}</label>
            <input
              :data-vv-as="$t('เบอร์โทรศัพท์')"
              v-validate="'required'"
              v-model="input.phoneNumber"
              class="form-control"
              type="number"
              name="เบอร์โทรศัพท์"
            />
            <span class="text-error" v-if="errors.has('เบอร์โทรศัพท์')">{{
              errors.first('เบอร์โทรศัพท์')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('ชื่อร้านค้า') }"
          >
            <label>{{ $t('ชื่อร้านค้า') }}</label>
            <input
              :data-vv-as="$t('ชื่อร้านค้า')"
              v-validate="'required'"
              v-model="input.shopName"
              class="form-control"
              type="text"
              name="ชื่อร้านค้า"
            />
            <span class="text-error" v-if="errors.has('ชื่อร้านค้า')">{{
              errors.first('ชื่อร้านค้า')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('ที่อยู่ร้านค้า') }"
          >
            <label>{{ $t('ที่อยู่ร้านค้า') }}</label>
            <input
              :data-vv-as="$t('ที่อยู่ร้านค้า')"
              v-validate="'required'"
              v-model="input.shopAddress"
              class="form-control"
              type="text"
              name="ที่อยู่ร้านค้า"
            />
            <span class="text-error" v-if="errors.has('ที่อยู่ร้านค้า')">{{
              errors.first('ที่อยู่ร้านค้า')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('เลขไปรษณีย์') }"
          >
            <label>{{ $t('เลขไปรษณีย์') }}</label>
            <input
              :data-vv-as="$t('เลขไปรษณีย์')"
              v-validate="'required'"
              v-model="input.shopPostcode"
              class="form-control"
              type="number"
              name="เลขไปรษณีย์"
            />
            <span class="text-error" v-if="errors.has('เลขไปรษณีย์')">{{
              errors.first('เลขไปรษณีย์')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('จังหวัด') }"
          >
            <label>{{ $t('จังหวัด') }}</label>
            <input
              :data-vv-as="$t('จังหวัด')"
              v-validate="'required'"
              v-model="input.shopProvince"
              class="form-control"
              type="text"
              name="จังหวัด"
            />
            <span class="text-error" v-if="errors.has('จังหวัด')">{{
              errors.first('จังหวัด')
            }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('เขต') }">
            <label>{{ $t('เขต') }}</label>
            <input
              :data-vv-as="$t('เขต')"
              v-validate="'required'"
              v-model="input.shopDistrict"
              class="form-control"
              type="text"
              name="เขต"
            />
            <span class="text-error" v-if="errors.has('เขต')">{{ errors.first('เขต') }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('แขวง') }">
            <label>{{ $t('แขวง') }}</label>
            <input
              :data-vv-as="$t('แขวง')"
              v-validate="'required'"
              v-model="input.shopSubDistrict"
              class="form-control"
              type="text"
              name="แขวง"
            />
            <span class="text-error" v-if="errors.has('แขวง')">{{ errors.first('แขวง') }}</span>
          </v-flex>
          <v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('เลขบัญชีธนาคาร') }"
          >
            <label>{{ $t('เลขบัญชีธนาคาร') }}</label>
            <input
              :data-vv-as="$t('เลขบัญชีธนาคาร')"
              v-validate="'required'"
              v-model="input.bankAccountNumber"
              class="form-control"
              type="number"
              name="เลขบัญชีธนาคาร"
            />
            <span class="text-error" v-if="errors.has('เลขบัญชีธนาคาร')">{{
              errors.first('เลขบัญชีธนาคาร')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('ชื่อธนาคาร') }"
          >
            <label>{{ $t('ชื่อธนาคาร') }}</label>
            <input
              :data-vv-as="$t('ชื่อธนาคาร')"
              v-validate="'required'"
              v-model="input.bank"
              class="form-control"
              type="text"
              name="ชื่อธนาคาร"
            />
            <span class="text-error" v-if="errors.has('ชื่อธนาคาร')">{{
              errors.first('ชื่อธนาคาร')
            }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('สาขา') }">
            <label>{{ $t('สาขา') }}</label>
            <input
              :data-vv-as="$t('สาขา')"
              v-validate="'required'"
              v-model="input.branch"
              class="form-control"
              type="text"
              name="สาขา"
            />
            <span class="text-error" v-if="errors.has('สาขา')">{{ errors.first('สาขา') }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
          <v-btn :loading="saveloading" @click="savedata" depressed color="primary">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        shopName: '',
        shopAddress: '',
        shopProvince: '',
        shopSubDistrict: '',
        shopDistrict: '',
        shopPostcode: '',
        bankAccountNumber: '',
        bank: '',
        branch: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      // this.input
      for (const key in this.input) {
        var newkey = key
        this.input[key] = this.editdata[newkey.toLowerCase()]
      }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editmember()
        }
      }
    },
    editmember() {
      var data = { pageid: this.selectedBot.pageid, ...this.input, memberId: this.editdata.id }
      this.saveloading = true
      api.updateYasaleMember(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    },
    createdata() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.createproducttoacrm(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/member/MemberEdit.vue